import { useStateStore } from '../../stores/useStateStore';

export const useCurrentDay = () => useStateStore((state) => state.current_day);
